module.exports = __webpack_public_path__ + "3ef67f09f187024f0b726166d2a945b6.png";